import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import {
  addAdversary,
  deleteAdversary,
  getAdversaries,
} from '../../dbAdversaries';
import postTranslations from '../../controllers/postTranslation';

export default class Adversary extends Component {
  state = {
    adversaryTranslatedText: '',
    adversaryTranslatedTitle: '',
    loadingAdversary: false,
  };

  async componentDidMount() {
    const { content, title, id, date } = this.props;
    const lang = localStorage.getItem('language').split('-')[0];
    const adversaryToTranslate = {
      title: title.rendered,
      text: content.rendered,
    };
    if (lang !== 'it') {
      const dataAdversaries = await getAdversaries();
      if (dataAdversaries) {
        const currentAdversary = dataAdversaries.find(
          adv => adv.idAdversary === id
        );
        if (currentAdversary) {
          this.setState({
            adversaryTranslatedTitle: currentAdversary?.title,
          });
          this.setState({
            adversaryTranslatedText: currentAdversary?.text,
          });
        }
      }
      const checkData = dataAdversaries.find(adv => adv.idAdversary === id);
      const checkDataByDate = checkData?.dateAdversary !== date;
      if (!checkData || checkDataByDate) {
        this.setState({ loadingAdversary: true });
        postTranslations(
          {
            title: adversaryToTranslate.title,
            text: adversaryToTranslate.text,
          },
          lang
        ).then(async res => {
          if (
            !res ||
            (res && res?.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              adversaryTranslatedTitle: adversaryToTranslate.title,
            });
            this.setState({
              adversaryTranslatedText: adversaryToTranslate.text,
            });
            this.setState({ loadingAdversary: false });
          } else {
            this.setState({
              adversaryTranslatedTitle: res?.translation?.title,
            });
            this.setState({
              adversaryTranslatedText: res?.translation?.text,
            });
            if (dataAdversaries) {
              const checkData = dataAdversaries.find(
                adv => adv.idAdversary === id
              );
              const checkDataByDate = dataAdversaries.find(
                adv => adv.idAdversary === id && adv.dateAdversary !== date
              );
              if (!checkData) {
                addAdversary({ ...res, idAdversary: id, dateAdversary: date });
              } else if (checkDataByDate) {
                deleteAdversary(checkDataByDate.id);
                addAdversary({ ...res, idAdversary: id, dateAdversary: date });
              }
            }
            this.setState({ loadingAdversary: false });
          }
        });
      }
    }
  }
  render() {
    const { adversary_country, content, featured_image, title } = this.props;
    const country = adversary_country && adversary_country[0].name;
    const lang = localStorage.getItem('language').split('-')[0];
    const {
      adversaryTranslatedText,
      adversaryTranslatedTitle,
      loadingAdversary,
    } = this.state;

    return (
      <li className="media mb-4 adversaries-list-item">
        <Row>
          <Col xl="4" lg="12">
            <Row className="imgs">
              <div className="col-6">
                <img
                  className="img-avatar img-fluid"
                  src={
                    featured_image ? featured_image : '/img/img-placeholder.jpg'
                  }
                  alt="Actor avatar"
                />
              </div>
              <div className="col-6">
                {country ? (
                  <img
                    className="img-flag img-fluid"
                    src={`/img/flags/${country}.png`}
                    alt={country}
                  />
                ) : (
                  <img
                    className="img-flag img-fluid"
                    src={`/img/flags/_noFlag.png`}
                    alt={`No Flag`}
                  />
                )}
              </div>
            </Row>
            {loadingAdversary && <p className="loader">translating...</p>}
          </Col>
          <Col xl="7" lg="12">
            <div className="media-body">
              <h3 className="mt-0 mb-1 media-heading adversary-title">
                <Link to={`/adversary/${title.rendered}`}>
                  {lang === 'it' || loadingAdversary
                    ? title.rendered
                    : adversaryTranslatedTitle}
                </Link>
              </h3>
              {content.rendered ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === 'it' || loadingAdversary
                        ? content.rendered
                        : adversaryTranslatedText,
                  }}
                />
              ) : (
                <span
                  dangerouslySetInnerHTML={{
                    __html: 'Al momento non ci sono altre informazioni.',
                  }}
                />
              )}
            </div>
          </Col>
        </Row>
      </li>
    );
  }
}
